module.exports = __webpack_public_path__ + "static/media/pathway-to-light.eab32078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/pathway-to-light.jpg
// module id = 314
// module chunks = 0